import { render, staticRenderFns } from "./AltTahsilatTuruForm.vue?vue&type=template&id=4220418d"
import script from "./AltTahsilatTuruForm.vue?vue&type=script&lang=ts"
export * from "./AltTahsilatTuruForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports